import styled from "styled-components";

export const Title = styled.div`
  font-family: Manrope;
  font-size: 20px;
  font-weight: 800;
  line-height: 28px;
  letter-spacing: 0em;
  text-align: left;
  margin-left: 10px;
  margin-top: 0;
`

export const SubTitle = styled.div`
  //styleName: Text/XL/2;
  font-family: Manrope;
  font-size: 18px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: 0em;
  text-align: left;
  padding-bottom: 12px;
  padding-top: 12px;
`

export const TextInfo = styled.div`
  //styleName: Text/L/1;
  font-family: Manrope;
  font-size: 16px;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: 0em;
  text-align: left;
  padding-bottom: 20px;
  color: rgba(128, 137, 146, 1);
`

export const ImgsWrapper = styled.div`
    display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr ;
`
export const ImgContent = styled.div`
  width: 184px;
  height: 260px;
  border-radius: 8px;
  margin: 24px 24px 24px 0;
  position: relative;

`
export const ImgCertificate=styled.img`
  width: 184px;
  height: 260px;
  object-fit: cover;
  border-radius: 8px;
 
`